<div class="p-grid">
  <div class="p-col-12">
    <h4>Chemical Information</h4>
  </div>
</div>
<form id="chemicalForm" #chemicalForm="ngForm">
  <div class="p-grid">
    <div class="p-col-3">
      <h6>Chemical Name</h6>
      <input pInputText fluid #chemicalNameInput name="name" required [(ngModel)]="chemical.chemicalName"/>
    </div>
    <div class="p-col-3">
      <h6>Trade Name</h6>
      <input pInputText fluid name="tradeName" required [(ngModel)]="chemical.tradeName"/>
    </div>
    <div class="p-col-3">
      <h6>Registration Number</h6>
      <input pInputText fluid name="registrationNumber" required [(ngModel)]="chemical.registrationNumber"/>
    </div>
    <div class="p-col-3">
      <h6>Mix Rate</h6>
      <input pInputText fluid name="mixRate" required [(ngModel)]="chemical.mixRate"/>
    </div>
    <div class="p-col-12 push-contents-to-bottom">
      <p-button
        
        type="submit"
        (click)="saveChemical(chemicalForm)"
        [disabled]="saving"
        severity="success"  
        label="Save">
      </p-button>
      <p-button 
        type="button"
        severity="warn"  
        (click)="clear(chemicalForm);"
        label="Clear">
      </p-button>
    </div>
  </div>
  <div class="p-col-12 columnPadding">
    @if (chemicalForm.invalid && chemicalForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
    }
  </div>
</form>
<br>
  <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="chemicals" [paginator]="true" [rows]="30">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-chemical
      let-columns="columns"
      let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{chemical.chemicalName}}</td>
        <td><span class="p-column-title">{{columns[1].header}}</span>{{chemical.tradeName}}</td>
        <td><span class="p-column-title">{{columns[2].header}}</span>{{chemical.registrationNumber}}</td>
        <td><span class="p-column-title">{{columns[3].header}}</span>{{chemical.mixRate}}</td>
        <td>
          <p-button
            type="button"
            icon="pi pi-pencil"
            (click)="editChemical(chemical)"
            severity="info" >
          </p-button>
          <p-button
            type="button"
            icon="pi pi-trash"
            (click)="deleteChemical(chemical)"
            severity="danger">
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <br>

